import StudentDashboard from '../pages/student/Dashboard';

const studentRoutes = [
  { path: 'dashboard', element: <StudentDashboard /> },
];

export default studentRoutes;
